import React, {Component, Fragment} from "react";
import moment from "moment";
import {FRIENDLY_DATETIME_FORMAT} from "../utils/Utils";


interface TimeTrafficCellContentProps
{
    date: string | Date | undefined;
    enableColour: boolean;
    amberOffset?: number;
    redOffset?: number;
}

interface TimeTrafficCellContentState
{
}

export default class TimeTrafficCellContent extends Component<TimeTrafficCellContentProps,TimeTrafficCellContentState>
{
    constructor(props: Readonly<TimeTrafficCellContentProps>) {
        super(props);

        this.state = {
        };
    }
    
    public render()
    {
        if(this.props.date === undefined)
        {
            return null;
        }

        let momentDate = moment(this.props.date);
        let className = "";

        if(this.props.enableColour)
        {
            let daysDiff = moment().diff(momentDate, 'days');

            if (this.props.redOffset !== undefined && daysDiff >= this.props.redOffset)
            {
                className += `pill pill--red`;
            }
            else if(this.props.amberOffset !== undefined && daysDiff >= this.props.amberOffset)
            {
                className += `pill pill--amber`;
            }
        }
        
        return (
            <Fragment>
                <span className={className}>{momentDate.fromNow()}</span>
                <span className="cdb-table__extra-detail">{momentDate.format(FRIENDLY_DATETIME_FORMAT)}</span>
            </Fragment>
        );
    }
}